module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_1.0ae4b731.mp3";